import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { TenantListPage } from '@/components/tenant-list-page'

export const Route = createFileRoute('/_app/tenants/current')({
	component: TenantCurrentPage,
})

function TenantCurrentPage() {
	const { t } = useTranslation()
	return (
		<TenantListPage
			period="current"
			emptyTitle={t('tenants.current.emptyTitle')}
			emptyDescription={t('tenants.current.emptyDescription')}
		/>
	)
}
